module.exports = __webpack_public_path__ + "img/camera-security.cbf1e11b.svg";